<template>
  <div>
    <div class="head">
      <div class="headLogo" @click="$router.push('/')">
        <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
      </div>
      <div class="ut">Mfo Eckz, Too</div>
    </div>
    <!-- 中间内容 -->
    <div class="minu">
      <div>
        <img class="minu_img" src="../../static/img/Ir.png" alt="" />
        <div class="minu_title">На рассмотрении</div>
        <div class="minu_text">Ваша заявка подана, пожалуйста, зайдите в приложение, чтобы проверить сумму</div>
        <div class="minu_btn" @click="googleFn">
          <!-- <img class="minu_btn-img" src="/static/img/google-play-badge.png" alt="" /> -->
          <div class="">Получить</div>
        </div>
      </div>
    </div>
    <!-- 底部协议 -->
    <div class="bom">
      <div class="bom_con">
        <div class="bom_con-text">Адрес:Казахстан, город Алматы, Бостандыкский район,улица Абиш Кекилбайулы, дом 34, офис</div>
        <div class="bom_minuIm">
          <div class="bom_con-num">Скачивай мобильное приложение через:</div>
          <div class="bom_minuIm">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt=""
              @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt="" @click="appstoreFn" />
          </div>
        </div>
      </div>
      <div class="bom_mi">
        <div class="bom_mi-text">Понедельник-пятница 9:00 - 21:00 Суббота-воскресенье 11:00 - 21:00</div>
        <div class="bom_mi-tit">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М,
          от 12.09.2024 года, выдана Управлением региональных представителей в городе Алматы Агентства Республики
          Казахстан по регулированию и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "underreview",
      data() {
        return {

        }
      },
      methods: {
        googleFn() {
          // location.href =
          //   'https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card'
          location.href = 'https://h5.fcredit.kz/?channel=website'
        },
        appstoreFn() {
          location.href = 'https://apps.apple.com/kz/app/%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B9-%D0%B7%D0%B0%D0%B9%D0%BC/id6751275518'
        }
      }
    }
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    border: none;
    Outline: none;
  }

  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.27rem;
    height: 0.27rem;
    cursor: pointer;
  }
  .ut{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
  }
  .minu {
    border-top: 0.01rem solid #C0C0C0;
    padding-top: 1.56rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.67rem;
    text-align: center;
  }
  .minu_img{
    width: 0.78rem;
    height: 0.78rem;
    margin-bottom: 0.21rem;
  }
  .minu_title{
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .minu_text{
    width: 2.18rem;
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.06rem;
    color: #333333;
    font-style: normal;
    margin: 0 auto 0.26rem;
  }
  .minu_btn{
    width: 2.81rem;
    height: 0.29rem;
    line-height: 0.29rem;
    background: #D4AF37;
    border-radius: 0.15rem;
    text-align: center;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .minu_btn-img{
    width: 0.53rem;
    height: 0.16rem;
    margin-right: 0.14rem;
  }

  /* 底部 */
  .bom {
    background: #F9F9F9;
    padding: 0.52rem 1.88rem;
  }

  .bom_con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.31rem;
  }

  .bom_con-text {
    width: 2.76rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
  }

  .bom_minuIm {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_con-num {
    width: 1.1rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.15rem;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
  }
  .bom_mi{
    display: flex;
    flex-direction: row;
  }
  .bom_mi-text{
    width: 1.78rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.4rem;
  }
  .bom_mi-tit{
    width: 4rem;
    height: 0.38rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/underreview.vue